import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { environment } from '@env/environment';
import { Store } from '@ngrx/store';
import { AuthActions } from '@shared/store';
import { AngularSvgIconModule } from 'angular-svg-icon';
declare var google: any;

@Component({
  selector: 'app-google-auth',
  templateUrl: './google-auth.component.html',
  styleUrls: ['./google-auth.component.scss'],
  standalone: true,
  imports: [AngularSvgIconModule],
})
export class GoogleAuthComponent implements OnInit {
  @ViewChild('googleSignInButton', { static: false }) googleSignInButton!: ElementRef;

  constructor(private store: Store, private ngZone: NgZone) {}

  ngOnInit(): void {
    // Ensure Google Identity Services library has loaded before initializing
    window.onload = () => {
      this.initializeGoogleSignIn();
    };
  }

  initializeGoogleSignIn(): void {
    // Set up the button and pass the callback function for handling the response
    google.accounts.id.initialize({
      client_id: environment.googleClientId,
      callback: this.handleCredentialResponse.bind(this),
      auto_select: false,
    });

    // Render the Google button invisibly
    google.accounts.id.renderButton(this.googleSignInButton.nativeElement, {
      theme: 'outline',
      size: 'large',
      width: 400, // Set width and height to zero for invisibility
    });
    this.googleSignInButton.nativeElement.style.opacity = 0;
    // this.googleSignInButton.nativeElement.style.pointerEvents = 'none'; // Ensure it doesn't interfere with layout
    // google.accounts.id.renderButton(document.getElementById('googleSignInButton'), { theme: 'outline', size: 'large' });
  }

  handleCredentialResponse(response: any) {
    const idToken = response.credential;
    if (idToken) {
      this.sendTokenToBackend(idToken);
    } else {
      console.error('ID token not received.');
    }
  }

  sendTokenToBackend(idToken: string): void {
    this.ngZone.run(() => {
      this.store.dispatch(AuthActions.loginWithGoogle({ idToken }));
    });
  }
}
